/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Images/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TemporaryImage from './TemporaryImage/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Images({
  children,
  viewPath = "/DesignSystem/PreviewResource/Content/Content/VideoFile/FrameGrabs/Content/Images"
  
}) {
let resourceCapturesValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'captures',
})
  return (<React.Fragment
>
<div
  data-testid="Images.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(resourceCapturesValueData) && resourceCapturesValueData.map((item, index, list) => 
<ListItem
        key={`${item?.id}`}
        context="temporary_image"
        item={item}
        index={index}
        list={list}
        hasItemKey={true}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TemporaryImage(${`${item?.id}`})`}
      >
<TemporaryImage
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TemporaryImage(${`${item?.id}`})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }